(() => {
    const log = window.tv2?.utils?.setupLog('📊 Datadog RUM') || console;
    const initAfterCMP = () => {
        if (window.__tcfapi === undefined) {
            setTimeout(initAfterCMP, 50);
            return;
        }
        const callback = (tcData, success) => {
            if (tcData.eventStatus === 'useractioncomplete' ||
                tcData.eventStatus === 'tcloaded') {
                if (tcData.purpose?.consents?.[8]) {
                    log.info('Consent granted (purpose 8), initializing');
                    initDatadogRum();
                }
                else {
                    log.info('Consent denied (purpose 8), not initializing');
                }
            }
            if (success && tcData.eventStatus === 'tcloaded') {
                window.__tcfapi('removeEventListener', 2, () => { }, callback);
            }
        };
        window.__tcfapi('addEventListener', 2, callback);
    };
    // Attaches the auth signal to RUM independently of the Adobe `pageLoad`
    // snapshot race. `subscribe` fires immediately if `traceIds` was already
    // published and again on every later publish (e.g. logout -> null), so the
    // context stays correct for the whole session.
    const attachAuthContext = () => {
        const ddRum = window.DD_RUM;
        if (!ddRum)
            return;
        // Mirror Adobe's three-state model; default until the auth flow resolves.
        ddRum.setGlobalContextProperty?.('loginStatus', 'userdata not responding');
        const messages = window.tv2messages;
        if (!messages)
            return;
        messages.subscribe('traceIds', (traceIds) => {
            if (traceIds) {
                ddRum.setGlobalContextProperty?.('loginStatus', 'logged in');
            }
            else {
                ddRum.setGlobalContextProperty?.('loginStatus', 'not logged in');
            }
        });
    };
    const initDatadogRum = () => {
        const { isTv2Prod, isTv2Staging } = window.tv2?.utils || {};
        const env = isTv2Prod ? 'prod' : isTv2Staging ? 'stage' : 'dev';
        (function (h, o, u, n, d) {
            h = h[d] = h[d] || {
                q: [],
                onReady: function (c) {
                    h.q.push(c);
                },
            };
            d = o.createElement(u);
            d.async = 1;
            d.src = n;
            d.crossOrigin = '';
            n = o.getElementsByTagName(u)[0];
            n.parentNode.insertBefore(d, n);
        })(window, document, 'script', 'https://www.datadoghq-browser-agent.com/eu1/v6/datadog-rum.js', 'DD_RUM');
        window.DD_RUM.onReady(function () {
            window.DD_RUM.init({
                applicationId: 'd42f2d3d-5a2c-4b7a-9656-5aa6e8b77509',
                clientToken: 'pub4a13ea11a16a9adefd49e41f5cdfa5f2',
                site: 'datadoghq.eu',
                service: 'tv2.dk',
                env,
                version: '1.0.0', // e.g. '1.0.0'
                sessionSampleRate: isTv2Prod ? 5 : 1,
                sessionReplaySampleRate: 0, // sessionReplay disabled
                trackResources: true, // disabled
                trackUserInteractions: false,
                trackLongTasks: true,
                allowFallbackToLocalStorage: true, // Needed for http://localhost
                trackSessionAcrossSubdomains: true, // Share session across *.tv2.dk
            });
            attachAuthContext();
        });
    };
    initAfterCMP();
})();
export {};
//# sourceMappingURL=datadog-rum.js.map